<template lang="pug">
  div.compare-bar(v-if="$store.getters['compare/items'].length > 0 && $route.name !== 'compare'")
    .container
      .row.align-items-center
        .col-12.col-xl
          .row
            .compare-bar__item-container
              .col.col-xl-auto.text-center.compare-bar__item(v-for="item in $store.getters['compare/items']" :key="item.item_code")
                  .compare-bar__close(@click="remove(item)")
                    font-awesome-icon(:icon=['far', 'times'])
                  router-link(:to='"/shop/product/" + item.item_code', :title="'ดูสินค้า ' + item.name")
                    img.compare-bar__item-thumbnail(:src="'https://www.sparkinter.com/imageproduct/' + item.item_code + '.jpg'" v-if="item.item_code")
                    h4.compare-bar__item-name {{ item.name }}
        .col-12.col-xl-auto.text-right
          .row.align-items-center.flex-row-reverse
            .col-6.col-xl-12.text-center
              router-link.btn.btn-primary(:to="{ name: 'compare' }") {{ trans('labels.frontend.compare.compare') }}
            .col-6.col-xl-12.text-center
              button.btn.btn-white.btn-sm(type="button" @click.prevent="reset") {{ trans('labels.general.buttons.cancel') }}
</template>

<script>
  export default {
    methods: {
      reset() {
        try {
          this.$store.dispatch('compare/empty', this.item);
        } catch (e) {
          console.log(e);
        }
      },
      remove(item) {
        try {
          this.$store.dispatch('compare/remove', item);
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
</script>
